module.exports = __webpack_public_path__ + "img/oc.84ad7f8d.jpg";